import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/perms";
import { Loader2 } from "lucide-react";

function Loading() {
  return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-accent" /></div>;
}

export function ProtectedRoute({ children, admin, agent }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  const role = user.role;
  // Admin shell: primary admins only. Agents are NEVER allowed here.
  if (admin && !["admin", "super_admin"].includes(role)) return <Navigate to={roleHome(user)} replace />;
  // Agent shell: agents only.
  if (agent && role !== "agent") return <Navigate to={roleHome(user)} replace />;
  // Customer shell: staff accounts are redirected to their own space.
  if (!admin && !agent && ["admin", "super_admin", "agent"].includes(role)) return <Navigate to={roleHome(user)} replace />;
  return children;
}
